import { Card, Checkbox, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import FormAction from "../../../../components/common/FormAction";

import { CgCloseO } from "react-icons/cg";
import { RiAddCircleFill } from "react-icons/ri";
import { BiMessageRounded } from "react-icons/bi";
import { FiMail } from "react-icons/fi";

import "./Contact.css";
import { numberType } from "../../../../utils/tenants";
import { states } from "../../../../utils/Util";
import { toast } from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";

function Contact({ data, peopleType, collectionName }) {
  const [checked, setChecked] = useState(false);
  const [phoneNumbers, setPhoneNumbers] = useState([
    { id: uuidv4(), type: "", phoneNumber: "", additionalDetails: "" },
  ]);
  const [emails, setEmails] = useState([{ id: uuidv4(), email: "" }]);
  const [addresses, setAddresses] = useState([
    {
      id: uuidv4(),
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
    },
  ]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(
            db,
            "companies",
            companyName,
            collectionName
          );
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label: doc.data().propertyGroupName,
            ...doc.data(),
          }));
          const filteredTenant = fetchedData.find(
            (item) => item.id === data?.id
          );
          console.log("filteredTenantfilteredTenantfilteredTenant",filteredTenant)
          console.log("datadatadatadatadatadatadata",data)
          setPhoneNumbers(
            filteredTenant?.contact?.phoneNumbers?.length >= 1
              ? filteredTenant?.contact?.phoneNumbers
              : [{ id: 1, type: "", phoneNumber: "", additionalDetails: "" }]
          );
          setEmails(
            filteredTenant?.contact?.emails?.length >= 1
              ? filteredTenant?.contact?.emails
              : [{ id: 1, email: "" }]
          );
          setAddresses(
            filteredTenant?.contact?.addresses?.length >= 1
              ? filteredTenant?.contact?.addresses
              : [
                  {
                    id: 1,
                    addressOne: "",
                    addressTwo: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    country: "",
                  },
                ]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, checked]);

  const handleNumberChange = (value, name, id) => {
    const updatedPhoneNumbers = phoneNumbers.map((phoneNumber) => {
      if (phoneNumber.id === id) {
        return { ...phoneNumber, [name]: value };
      }
      return phoneNumber;
    });
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const addPhoneNumber = () => {
    const newPhoneNumber = {
      id: uuidv4(),
      type: "",
      phoneNumber: "",
      additionalDetails: "",
    };
    setPhoneNumbers([...phoneNumbers, newPhoneNumber]);
  };

  const removePhoneNumber = (id) => {
    const updatedPhoneNumbers = phoneNumbers.filter(
      (phoneNumber) => phoneNumber.id !== id
    );
    setPhoneNumbers(updatedPhoneNumbers);
  };

  //Emails adding

  const handleEmailChange = (value, name, id) => {
    const updatedEmails = emails.map((email) => {
      if (email.id === id) {
        return { ...email, [name]: value };
      }
      return email;
    });
    setEmails(updatedEmails);
  };

  const addEmail = () => {
    const newEmail = {
      id: uuidv4(),
      email: "",
    };
    setEmails([...emails, newEmail]);
  };

  const removeEmail = (id) => {
    const updatedEmails = emails.filter((email) => email.id !== id);
    setEmails(updatedEmails);
  };

  //Address adding

  const handleAddressChange = (value, name, id) => {
    const updatedAddresses = addresses.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAddresses(updatedAddresses);
  };

  const addAddress = () => {
    const newAddress = {
      id: uuidv4(),
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
    };
    setAddresses([...addresses, newAddress]);
  };

  const removeAddress = (id) => {
    const updatedAddresses = addresses.filter((item) => item.id !== id);
    setAddresses(updatedAddresses);
  };

  // const [phoneNumbers, setPhoneNumbers] = useState([
  //   { number: "", type: "", detail: "" },
  // ]);
  // const [emails, setEmails] = useState([{ email: "" }]);

  // const [addresses, setAddresses] = useState([
  //   {
  //     address: "",
  //     addressTwo: "",
  //     City: "",
  //     state: "",
  //     zipCode: "",
  //     country: "",
  //   },
  // ]);

  // const addAnotherAddress = () => {
  //   setAddresses([
  //     ...addresses,
  //     {
  //       address: "",
  //       addressTwo: "",
  //       City: "",
  //       state: "",
  //       zipCode: "",
  //       country: "",
  //     },
  //   ]);
  // };

  // const onRemoveAddress = (index) => {
  //   const newAddresses = [...addresses];
  //   newAddresses.splice(index, 1);
  //   setAddresses(newAddresses);
  // };

  // const addAnotherEmail = () => {
  //   setEmails([...emails, { email: "" }]);
  // };

  // const onRemoveEmail = (index) => {
  //   const newEmails = [...emails];
  //   newEmails.splice(index, 1);
  //   setEmails(newEmails);
  // };

  // const addAnotherNumber = () => {
  //   setPhoneNumbers([...phoneNumbers, { number: "", type: "", detail: "" }]);
  // };

  // const onRemoveNumber = (index) => {
  //   const newNumbers = [...phoneNumbers];
  //   newNumbers.splice(index, 1);
  //   setPhoneNumbers(newNumbers);
  // };

  const onCancel = () => {
    setChecked(false);
  };

  const updateContact = () => {
    try {
      const tenantRef = doc(
        db,
        "companies",
        companyName,
        collectionName,
        data?.id
      );
      const filteredPhoneNumbers = phoneNumbers.filter((item) => {
        return Object.keys(item).some(
          (key) => key !== "id" && item[key] !== ""
        );
      });
      const filteredEmails = emails.filter((item) => {
        return Object.keys(item).some(
          (key) => key !== "id" && item[key] !== ""
        );
      });
      const filteredAddresses = addresses.filter((item) => {
        return Object.keys(item).some(
          (key) => key !== "id" && item[key] !== ""
        );
      });
      const vehiclesObj = {
        "contact.phoneNumbers": filteredPhoneNumbers,
        "contact.emails": filteredEmails,
        "contact.addresses": filteredAddresses,
      };
      updateDoc(tenantRef, vehiclesObj);
      setChecked(false);
      toast.success("Vendor pets info updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  const onFinishFailed = (err) => {
    console.log(err);
  };
  return (
    <Card
      title="Contact"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          className="contact-form"
          onFinish={updateContact}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <strong>Phone Numbers</strong>
                </Col>
                <Col span={24}>
                  <Row gutter={[0, 8]}>
                    {phoneNumbers.map((item, index) => {
                      return (
                        <Col span={24} key={index}>
                          <Row justify="space-between" align="middle">
                            <Col span={22}>
                              <Row gutter={[0, 8]}>
                                <Col span={22} className="number">
                                  <Form.Item>
                                    <Input
                                      value={item.phoneNumber}
                                      onChange={(e) =>
                                        handleNumberChange(
                                          e.target.value,
                                          "phoneNumber",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                  <Form.Item>
                                    <Select
                                      options={numberType}
                                      placeholder="Select"
                                      value={item.type}
                                      onChange={(value) =>
                                        handleNumberChange(
                                          value,
                                          "type",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={22}>
                                  <Form.Item>
                                    <Input
                                      placeholder="Description"
                                      value={item.additionalDetails}
                                      onChange={(e) =>
                                        handleNumberChange(
                                          e.target.value,
                                          "additionalDetails",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            {phoneNumbers.length > 1 ? (
                              <Col
                                className="number-delete"
                                onClick={() => removePhoneNumber(item.id)}
                                span={2}
                              >
                                <CgCloseO size={18} />
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      );
                    })}
                    <Col span={24}>
                      <button
                        className="add-icon-btn"
                        onClick={() => addPhoneNumber()}
                        type="button"
                      >
                        <RiAddCircleFill size={18} />
                        Add Another Phone Number
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <strong>Emails</strong>
                </Col>
                <Col span={24}>
                  <Row gutter={[0, 8]}>
                    {emails.map((item, index) => {
                      return (
                        <Col span={24} key={index}>
                          <Row justify="space-between" align="middle">
                            <Col span={22}>
                              <Form.Item rules={[{ type: "email" }]}>
                                <Input
                                  value={item.email}
                                  onChange={(e) =>
                                    handleEmailChange(
                                      e.target.value,
                                      "email",
                                      item.id
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            {emails.length > 1 ? (
                              <Col
                                span={1}
                                onClick={() => removeEmail(item.id)}
                                className="email-delete"
                              >
                                <CgCloseO size={18} />
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      );
                    })}
                    <Col span={24}>
                      <button
                        className="add-icon-btn"
                        onClick={() => addEmail()}
                        type="button"
                      >
                        <RiAddCircleFill size={18} />
                        Add Another Phone Number
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <strong>Addresses</strong>
                </Col>
                <Col span={24}>
                  <Row gutter={[0, 8]}>
                    {addresses.map((item, index) => {
                      return (
                        <Col span={24} key={index}>
                          <Row justify="space-between" align="middle">
                            <Col span={22}>
                              <Row gutter={[0, 8]}>
                                <Col span={22}>
                                  <Form.Item>
                                    <Input
                                      placeholder="Address 1"
                                      value={item.addressOne}
                                      onChange={(e) =>
                                        handleAddressChange(
                                          e.target.value,
                                          "addressOne",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={22}>
                                  <Form.Item>
                                    <Input
                                      placeholder="Address 2"
                                      value={item.addressTwo}
                                      onChange={(e) =>
                                        handleAddressChange(
                                          e.target.value,
                                          "addressTwo",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={22} className="address">
                                  <Form.Item>
                                    <Input
                                      placeholder="City"
                                      value={item.city}
                                      onChange={(e) =>
                                        handleAddressChange(
                                          e.target.value,
                                          "city",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                  <Form.Item>
                                    <Select
                                      options={states}
                                      placeholder="Select..."
                                      value={item.state}
                                      onChange={(value) =>
                                        handleAddressChange(
                                          value,
                                          "state",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                  <Form.Item>
                                    <Input
                                      placeholder="Zip code"
                                      value={item.zipCode}
                                      onChange={(e) =>
                                        handleAddressChange(
                                          e.target.value,
                                          "zipCode",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={22}>
                                  <Form.Item>
                                    <Input
                                      placeholder="State Country"
                                      value={item.country}
                                      onChange={(e) =>
                                        handleAddressChange(
                                          e.target.value,
                                          "country",
                                          item.id
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            {addresses.length > 1 ? (
                              <Col
                                span={2}
                                className="delete-btn"
                                onClick={() => removeAddress(item.id)}
                              >
                                <CgCloseO size={18} />
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      );
                    })}

                    <Col span={24}>
                      <button
                        className="add-icon-btn"
                        onClick={() => addAddress()}
                        type="button"
                      >
                        <RiAddCircleFill size={18} />
                        Add Another Phone Number
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            {peopleType === "Tenant" ? (
              <Col span={24}>
                <Form.Item>
                  <Checkbox checked disabled>
                    Primary Tenant
                  </Checkbox>
                </Form.Item>
              </Col>
            ) : null}

            {peopleType === "Owner" ? (
              <Col span={24}>
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <strong>Payment Address</strong>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="">
                      <Checkbox>Use owner address as payment address</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>{" "}
              </Col>
            ) : null}

            {peopleType === "Vendor" ? (
              <Col span={24}>
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <strong>1099 Address</strong>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="">
                      <Checkbox>Use vendor address as 1099 address</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>{" "}
              </Col>
            ) : null}
          </Row>
          <FormAction
            className="contact-actions"
            submit="submit"
            cancel={onCancel}
          />
        </Form>
      ) : (
        <Row gutter={[0, 8]} className="contact-form">
          <Col span={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <strong>Phone Numbers</strong>
              </Col>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                >
                  <Form.Item label="Mobile">
                    <div className="mobile-container">
                      <p className="onclick-text">
                        {data?.contact?.phoneNumbers.length > 0
                          ? data?.contact?.phoneNumbers[0]?.phoneNumber
                          : "--"}
                      </p>
                      <button className="icon-btn">
                        <BiMessageRounded size={16} />
                        <span>Text</span>
                      </button>
                    </div>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <strong>Emails</strong>
              </Col>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                >
                  <Form.Item label="Email">
                    <div className="email-container">
                      <p className="onclick-text">
                        {data?.contact?.emails.length > 0
                          ? data?.contact?.emails[0]?.email
                          : "--"}
                      </p>
                      <button className="icon-btn">
                        <FiMail size={16} />
                        <span>Email</span>
                      </button>
                    </div>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <strong>Addresses</strong>
              </Col>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                >
                  <Form.Item label="address">
                    <p>
                      {data?.contact?.addresses.length > 0
                        ? data.contact.addresses[0].addressOne +
                          " " +
                          data.contact.addresses[0].city +
                          ", " +
                          data.contact.addresses[0].state +
                          " " +
                          data.contact.addresses[0].zipCode
                        : "--"}
                    </p>
                  </Form.Item>
                  <Form.Item label="address">
                    <p>
                      {data?.contact?.addresses.length > 0
                        ? data.contact.addresses[0].addressTwo +
                          " " +
                          data.contact.addresses[0].city +
                          ", " +
                          data.contact.addresses[0].state +
                          " " +
                          data.contact.addresses[0].zipCode
                        : ""}
                    </p>
                  </Form.Item>
                  {peopleType === "Tenant" ? (
                    <Form.Item label="Primary Tenant">
                      <p>{data?.primaryTenant}</p>
                    </Form.Item>
                  ) : null}
                </Form>
              </Col>
            </Row>
          </Col>
          <Col span={24}></Col>
        </Row>
      )}
    </Card>
  );
}

export default Contact;
